"use strict";
/**
 * Ελληνικές ετικέτες αναφορών — αποφυγή αγγλικών όρων στο UI.
 *
 * «Pipeline» προσφορών = πρόχειρες + σταλμένες (αναμονή απόφασης).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPORT_OFFER_STATUS_LABELS = exports.OFFER_WON_VALUE_METRIC = exports.OFFER_WON_SECTION_TITLE = exports.OFFER_WON_LABEL = exports.OFFER_PIPELINE_EMPTY_MESSAGE = exports.OFFER_PIPELINE_VALUE_METRIC = exports.OFFER_PIPELINE_SECTION_TITLE_LONG = exports.OFFER_PIPELINE_SECTION_TITLE = exports.OFFER_PIPELINE_WAITING_LABEL = void 0;
/** Τίτλος πίνακα / ενότητας / μετρικής — προσφορές χωρίς απόφαση */
exports.OFFER_PIPELINE_WAITING_LABEL = 'Αναμονή Απόφασης';
exports.OFFER_PIPELINE_SECTION_TITLE = exports.OFFER_PIPELINE_WAITING_LABEL;
/** Τίτλος πίνακα σύνοψης με διευκρίνιση καταστάσεων */
exports.OFFER_PIPELINE_SECTION_TITLE_LONG = 'Αναμονή Απόφασης (πρόχειρες / σταλμένες)';
exports.OFFER_PIPELINE_VALUE_METRIC = exports.OFFER_PIPELINE_WAITING_LABEL;
exports.OFFER_PIPELINE_EMPTY_MESSAGE = 'Δεν υπάρχουν προσφορές σε αναμονή απόφασης.';
/** Προσφορές με κατάσταση ACCEPTED */
exports.OFFER_WON_LABEL = 'Κερδισμένες';
exports.OFFER_WON_SECTION_TITLE = exports.OFFER_WON_LABEL;
exports.OFFER_WON_VALUE_METRIC = exports.OFFER_WON_LABEL;
/** Ετικέτες κατάστασης προσφοράς σε αναφορές */
exports.REPORT_OFFER_STATUS_LABELS = {
    draft: 'Πρόχειρες',
    sent: 'Σταλμένες',
    accepted: exports.OFFER_WON_LABEL,
    rejected: 'Απορριφθείσες',
    archived: 'Αρχειοθετημένες',
};
